import React from 'react';
import styled from 'styled-components/macro';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import { useTranslation } from 'react-i18next';

export const DisplayBooleanHorizontal = props => {
  const { value, label, displayChange } = props;
  const { t } = useTranslation();

  return (
    <Wrapper>
      <div className='boolean-label'>{t(label)}: </div>
      <div className={`${(displayChange) && 'pendding-color'}`}>
        {value ? <CheckOutlinedIcon /> : <CloseOutlinedIcon />}
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  width: inherit;
  margin: 0 5px;
  align-items: center;

  .pendding-color {
    background-color: ${p => p.theme.pending};
    border-radius: 5px;
  }

  .boolean-label {
    padding-left: 5px;
  }
`;
